exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".training-project-sessions-list thead tr th {\n  user-select: none;\n}\n", ""]);

// exports
